import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { CalloutButton } from './CalloutButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CalloutBanner({
  title,
  description,
  buttonText,
  buttonUrl,
  logoUrl,
  logoAlt = '',
  onClick,
  openCopilot,
  CtaButton = CalloutButton
}) {
  const {
    isMobile
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      md: false
    }
  });
  const logo = logoUrl ? /*#__PURE__*/_jsx(View, {
    flexShrink: 0,
    children: /*#__PURE__*/_jsx(Image, {
      alt: logoAlt,
      blockSize: "48px",
      borderRadius: "full",
      inlineSize: "48px",
      loading: "lazy",
      objectFit: "contain",
      responsive: false,
      src: logoUrl
    })
  }) : null;
  const titleAndDescription = /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    flex: "1",
    minInlineSize: "0",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      typography: "heading-300",
      children: title
    }), /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      typography: "body-200",
      children: description
    })]
  });
  const cta = /*#__PURE__*/_jsx(View, {
    flexShrink: 0,
    children: /*#__PURE__*/_jsx(CtaButton, {
      buttonText: buttonText,
      buttonUrl: buttonUrl,
      onClick: onClick,
      openCopilot: openCopilot,
      use: "secondary"
    })
  });
  return /*#__PURE__*/_jsx(CardWrapper, {
    margin: "0",
    overflow: "hidden",
    children: /*#__PURE__*/_jsx(CardSection, {
      padding: "0",
      margin: "0",
      children: isMobile ? /*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        flexDirection: "column",
        gap: "400",
        paddingBlock: "400",
        paddingInline: "600",
        children: [logo, titleAndDescription, cta]
      }) : /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "row",
        gap: "1100",
        paddingBlock: "400",
        paddingInline: "1100",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "400",
          flex: "1",
          minInlineSize: "0",
          children: [logo, titleAndDescription]
        }), cta]
      })
    })
  });
}